import React from 'react';
import { useUserStats } from '../../hooks/useLabs';
import './Labs.css';

export const UserStats = () => {
  const { totalXP, currentRank, completedLevels, competencies, achievements } = useUserStats();

  return (
    <div className="user-stats">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">⭐</div>
          <div className="stat-content">
            <h3>{currentRank.name}</h3>
            <p>Rango Actual</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">✨</div>
          <div className="stat-content">
            <h3>{totalXP}</h3>
            <p>Puntos de Experiencia</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🏆</div>
          <div className="stat-content">
            <h3>{completedLevels}</h3>
            <p>Niveles Completados</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🎓</div>
          <div className="stat-content">
            <h3>{achievements.length}</h3>
            <p>Logros Desbloqueados</p>
          </div>
        </div>
      </div>

      <div className="stats-section">
        <h3>Competencias Aprendidas</h3>
        <div className="competencies-list">
          {competencies.length > 0 ? (
            competencies.map((comp, i) => (
              <span key={i} className="competency-badge">{comp}</span>
            ))
          ) : (
            <p>Completa niveles para aprender competencias</p>
          )}
        </div>
      </div>

      <div className="stats-section">
        <h3>Logros</h3>
        <div className="achievements-grid">
          {achievements.length > 0 ? (
            achievements.map((achievement, i) => (
              <div key={i} className="achievement-item">
                <div className="achievement-icon">{achievement.icono}</div>
                <h4>{achievement.titulo}</h4>
                <p>{achievement.descripcion}</p>
              </div>
            ))
          ) : (
            <p>Sin logros aún. ¡Completa niveles para obtenerlos!</p>
          )}
        </div>
      </div>
    </div>
  );
};
